import React from 'react';

import ConnectionStatus from './components/ConnectionStatus';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';

import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ConnectionStatus />
        <Routes />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;